<template>
  <div>
    <CChartLine
      :datasets="datasets"
      :labels="labels"
      :options="options"
      :style="`height: ${height}px`"
    />
  </div>
</template>

<script>
import { CChartLine } from "@coreui/vue-chartjs";

export default {
  name: "BasicLine",
  components: { CChartLine },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        animation: {
          duration: 0,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#fff",
            anchor: "end",
            align: "start",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value,
          }
        },
      }),
    },
    height: {
      type: Number,
      default: 200,
    },
  },
  computed: {
    datasets() {
      return this.data.map((item) => ({
        label: item.name,
        backgroundColor: item.backgroundColor,
        ...item.borderColor && { borderColor: item.borderColor },
        data: item.values.map((value) => value.value),
        ...(item.type === "line" && { type: item.type, tension: item.tension, fill: item.fill }),
        barThickness: 20
      }));
    },
    labels() {
      const firstBar = this.data.length ? this.data[0].values : [];
      const labels = firstBar?.map((item) => item.name) || [];
      return labels;
    },
  },
};
</script>
<style lang="scss" scoped>
.pie-legend {
  display: flex;
  flex-flow: row wrap;
  .legend {
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 5px 0;
    .legend-count {
      font-weight: 600;
      font-size: 16px;
    }
    .label {
      margin: 0;
      // white-space: nowrap;
      font-size: 11px;
      word-break: break-word;
      text-align: center;
    }
  }
  @media only screen and (max-width: 320px) {
    .pie-legend {
      .legend {
        width: 33%;
      }
    }
  }
}
</style>
